<h3>{{pageLabel}}</h3>

<div class="newUserGroup">

	<div>
	<label class="dataLabel">User Name: </label>
	<input type="text" pInputText [disabled]="disableUsername" [(ngModel)]="user.username" />
	<p-message [ngClass]="{hidden:!usernameWarningVisible}" severity="error" text="Username must be specified."></p-message>
	</div>
	
	<div class="oneLine">
	<label class="dataLabel">Name: </label>
	<input type="text" pInputText [(ngModel)]="user.name" />
	<p-message [ngClass]="{hidden:!nameWarningVisible}" severity="error" text="Name must be specified."></p-message>
	</div>

	<label class="dataLabel">Title: </label>
	<input type="text" pInputText [(ngModel)]="user.title" />

	<label class="dataLabel">Email Address: </label>
	<input type="email" pInputText [(ngModel)]="user.email" email />
	<p-message [ngClass]="{hidden:!emailWarningVisible}" severity="error" text="Valid email must be specified."></p-message>

	<label class="dataLabel">Organization: </label>
	<input type="text" pInputText [(ngModel)]="user.organization" />

	<label class="dataLabel">Address: </label>
	<input type="text" pInputText [(ngModel)]="user.address" />

	<label class="dataLabel">Phone: </label>
	<input type="text" pInputText [(ngModel)]="user.phone" />

	<label class="dataLabel">Mobile Phone: </label>
	<input type="text" pInputText [(ngModel)]="user.mobile" />

	<div style="clear:both">
	<label class="dataLabel">Password: </label>
	<input id="passwordField" type="password" pPassword pInputText [(ngModel)]="user.password" /> 
	<span id="passwordToggle" class="fa fa-fw fa-eye field-icon toggle-password" [ngClass]="{'fa-eye-slash':showPassword}" (click)="togglePassword()"></span>{{passwordNote}}
	<p-message [ngClass]="{hidden:!passwordWarningVisible}" severity="error" text="Initial password must be specified."></p-message>
	</div>

	<div style="clear:left">
	<label class="dataLabel">Roles: </label>
		<div class="rolesContainer">
			
			<table>
				<!-- 

				<tr *ngFor="let role of availableRoles">
					<td>
					<label class="rolesLabel">
						<input type="checkbox" id={{role.id}} class="roleCheckbox">{{role.name}} ({{role.description}})
						<div class="title" *ngFor="let permission of role.permissionList"><span class="thick">{{permission.name}}</span> {{permission.description}}</div>
					</label>
					</td>
				</tr>
				-->

				<!--
					Try using primeng component
				-->
				<tr *ngFor="let role of availableRoles" class="p-field-checkbox">
					<td>
						<p-checkbox styleClass="roleCheckbox" [inputId]="role.id" [ngModel]="selectedRoles" value="role" [value]="role" [disabled]="!assignRolePermission"></p-checkbox>
						<label [for]="role.id" class="rolesLabel" pTooltip={{role.tooltip}} [escape]=false>{{role.label}}</label>
						<!-- <div class="title" *ngFor="let permission of role.permissionList"><span class="thick">{{permission.name}}</span> {{permission.description}}</div> -->
					</td>
				</tr>
			</table>
		
		</div>
		<p-message [ngClass]="{hidden:!rolesWarningVisible}" severity="error" text="At least 1 role must be assigned."></p-message>
	</div>
	
	<div class="bottomButtons">
		<button (click)="submitUser()">Update Profile</button>
		<button (click)="goBack()" type="button">Cancel</button>
	</div>						

</div>